var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.79 40a18.46 18.46 0 012.32-8.08L46.22 40l23.89 8.08A18.46 18.46 0 0167.79 40",
    fill: "#1f816c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.21 40a18.46 18.46 0 01-2.32 8.08L33.78 40 9.89 31.92A18.46 18.46 0 0112.21 40",
    fill: "#247e92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 67.79a18.46 18.46 0 018.08 2.32L40 46.22l-8.08 23.89A18.46 18.46 0 0140 67.79",
    fill: "#28628e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 12.21a18.46 18.46 0 01-8.08-2.32L40 33.78l8.08-23.89A18.46 18.46 0 0140 12.21",
    fill: "#c93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.65 20.35A18.4 18.4 0 0155.58 13L44.4 35.6 67 24.42a18.4 18.4 0 01-7.35-4.07",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.35 59.65A18.4 18.4 0 0124.42 67L35.6 44.4 13 55.58a18.4 18.4 0 017.35 4.07",
    fill: "#b9582f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.65 59.65A18.4 18.4 0 0167 55.58L44.4 44.4 55.58 67a18.4 18.4 0 014.07-7.35",
    fill: "#876b8b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.35 20.35A18.4 18.4 0 0113 24.42L35.6 35.6 24.42 13a18.4 18.4 0 01-4.07 7.35",
    fill: "#c74759"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/appLogo.2357d11ddcc39af6f2b1333d74ca9024.svg";
export { ForwardRef as ReactComponent };